module.exports = __webpack_public_path__ + "img/scheme.b0a54371.jpg";